import Markdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";
import rehypeHighlight from "rehype-highlight";
import Code from "./markdown-components/code";
import {
  TableRoot,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from "./markdown-components/table";
import OutputImage from "./markdown-components/images/output-image";
import { GamgeeChatMessageRead } from "~/types/message";
import { useMemo } from "react";

const MarkdownContainer = function MarkdownContainer({
  children,
  message,
}: {
  children: any;
  message: GamgeeChatMessageRead;
}) {
  const components = useMemo(
    () => ({
      code: Code as any,
      table: TableRoot as any,
      thead: TableHeader as any,
      tbody: TableBody as any,
      tr: TableRow as any,
      th: TableHead as any,
      td: TableCell as any,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      img: ({ node, ...props }: any) => (
        <OutputImage {...props} message={message} />
      ),
    }),
    [message._id, message.session_id]
  );
  return (
    <div className="prose max-w-none px-6">
      <Markdown
        remarkPlugins={[remarkBreaks, remarkGfm]}
        rehypePlugins={[rehypeHighlight]}
        components={components}
      >
        {children}
      </Markdown>
    </div>
  );
};

export default MarkdownContainer;
